<ng-container *ngIf="product$ | async as product">
  <div class="material-note-container">
      <div class="sp-note-container">
        <span>
          <strong>Note: </strong>
          <span [innerHTML]="(product?.materialNotes  || '') | safe"></span>
        </span>
      </div>
  </div>
</ng-container>